import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import 'hammerjs';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// import {ServiceWorkerModule} from '@angular/service-worker';

import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {AppComponent} from './app.component';
import {MatIconRegistry} from '@angular/material';
import {appRouting} from './app.routing';
import {environment} from '../environments/environment';

import {locale, loadMessages} from 'devextreme/localization';
import 'devextreme-intl';
import * as messagesPt from 'devextreme/localization/messages/pt.json';

loadMessages(messagesPt);
locale(navigator.language);

@NgModule({
  declarations: [
    AppComponent,
    appRouting.components
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule.forRoot(),
    SharedModule,
    appRouting.routes
    // ,
    // ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production})
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public matIconRegistry: MatIconRegistry) {
    matIconRegistry.registerFontClassAlias('fontawesome', 'fal');
  }
}
